import { render } from "./CabinetHeader.vue?vue&type=template&id=4a1cdaca&ts=true&lang=pug"
import script from "./CabinetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CabinetHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__